import PropTypes from 'prop-types'

/*const pointOfSalesShape = PropTypes.shape({
  id: PropTypes.number,
  distributorCode: PropTypes.string,
  mainBrand: PropTypes.number,
  name: PropTypes.string,
  adress1: PropTypes.string,
  adress2: PropTypes.string,
  adress3: PropTypes.string,
  zipCode: PropTypes.string,
  city: PropTypes.string,
  email: PropTypes.string,
  phone1: PropTypes.string,
  phone2: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
  entityName: PropTypes.string,
  DPOName1: PropTypes.string,
  DPOName2: PropTypes.string,
  DPOEmail: PropTypes.string
})*/

const colorShape = PropTypes.shape({
  bg: PropTypes.string
})

const themeShape = PropTypes.shape({
  name: PropTypes.string,
  colors: PropTypes.shape({
    color1: colorShape,
    color2: colorShape,
    color3: colorShape,
    color4: colorShape,
    color5: colorShape,
    color6: colorShape,
    color7: colorShape
  })
})

const configurationShape = PropTypes.shape({
  //pointOfSales: pointOfSalesShape,
  theme: themeShape,
  campaign: PropTypes.shape()
})

export default configurationShape
